import { vuex as login } from './login'
import { routes as course } from './course'
import { routes as channel } from './channel'
import { routes as user } from './user'
import { routes as assessment } from './assessment'
import { routes as learningContent } from './learningContent'
import { routes as search } from './search'
import { routes as dashboard } from './dashboard'
import { routes as folderManagement } from './folderManagement'
import { routes as semester } from './semester'
import { routes as employer } from './employer'
import { routes as job } from './job'
import { routes as sharing } from './sharing'
import { routes as stream } from './stream'
import { routes as advancedSearch } from './advancedSearch'
import { routes as quickLink } from './quickLink'
import { routes as adviseeTracker } from './adviseeTracker'
import { routes as club } from './club'
import { routes as event } from './event'
import { routes as catalog } from './catalog'
import { routes as guest } from './guest'
import { routes as tool } from './tool'
import { routes as quest } from './quest'
import { routes as person } from './person'
import { routes as career } from './career'
import { routes as programguide } from './programguide'
import { routes as coacheeTracker } from './coacheeTracker'
import { routes as taskMonitor } from './taskMonitor'
import { routes as explore } from './explore'
import { routes as institution } from './institution'
import { routes as tagging } from './tagging'
import { routes as help } from './help'
import { routes as group } from './group'
import { routes as connector } from './connector'
import { routes as transfer } from './transfer'
import { routes as widget } from './widget'
import { routes as microCompetency } from './microCompetency'

export default [ ...login, ...course, ...channel, ...user, ...assessment, ...learningContent, ...search, ...dashboard, ...folderManagement, ...semester, ...employer, ...job, ...sharing, ...stream, ...advancedSearch, ...quickLink, ...adviseeTracker, ...club, ...event, ...catalog, ...guest, ...tool, ...person, ...quest, ...career, ...programguide, ...taskMonitor, ...coacheeTracker, ...explore, ...institution, ...tagging, ...help, ...group, ...connector, ...transfer, ...widget, ...microCompetency ]



// WEBPACK FOOTER //
// ./src/app/routes.js